<ng-container>
    <span
        role="heading"
        aria-level="4"
    >
        <button
            [id]="buttonId"
            type="button"
            class="faq-headline block fw:bold left"
            (click)="open = !open"
            [ngClass]="{ '-open': open }"
            [attr.aria-expanded]="open"
            [attr.aria-controls]="sectionId"
        >
            @if (headlineAsTemplate()) {
                <ng-container [ngTemplateOutlet]="headlineAsTemplate()"></ng-container>
            } @else {
                {{ headline() }}
            }
        </button>
    </span>
    <div
        [id]="sectionId"
        class="faq-content"
        [ngClass]="{ hide: !open }"
        [attr.aria-labelledby]="buttonId"
    >
        <ng-content></ng-content>
    </div>
</ng-container>
